<template>
  <form role="form">
    <div class="row justify-content-md-center">
      <div class="col-12 form-group" v-if="copyCicle">
        <label class="form-control-label">Cliente <span style="color:red;">*</span></label>
        <multiselect
          v-model="value.client"
          :options="clients"
          placeholder="Selecione um Cliente"
          label="razao_social"
          track-by="id"
          :preserveSearch="true"
          :showNoResults="false"
          :select-label="''"
          :selected-label="'Selecionado'"
          :deselect-label="''"
          :required="true"
          @search-change="getClients"
        ></multiselect>
      </div>
      <div class="col-12 col-sm-6">
        <label class="form-control-label">Identificação <span style="color:red;">*</span></label>
        <base-input
          class="mb-3"
          v-model="value.description"
          placeholder="Ex: Ciclo 1"
          :required="true"
        >
        </base-input>
      </div>
      <div class="col-12 col-sm-6 form-group">
        <label class="form-control-label">Classificação <span style="color:red;">*</span></label>
        <multiselect
          v-model="value.cicle_classification"
          :options="classification_options"
          group-values="classifications"
          group-label="origin"
          :group-select="false"
          placeholder="Selecione o período"
          label="name"
          track-by="id"
          :allow-empty="false"
          :preserveSearch="true"
          :showNoResults="false"
           @input="sendChange"
          :select-label="''"
          :selected-label="'Selecionado'"
          :deselect-label="''"
          @search-change="updateNewClassificationName"
        ></multiselect>
      </div>
      <div class="col-12 col-md-4 form-group">
        <label class="form-control-label">Ano Safra <span style="color:red;">*</span></label>
        <multiselect
          v-model="value.anosafra"
          @input="sendChange"
          :options="anosafras"
          placeholder="Selecione o Ano Safra"
          label="descricao"
          track-by="id"
          :preserveSearch="true"
          :showNoResults="false"
          :select-label="''"
          :selected-label="'Selecionado'"
          :deselect-label="''"
        ></multiselect>
      </div>
      <div class="col-6 col-md-5 form-group">
        <label class="form-control-label">Período do Ciclo <span style="color:red;">*</span></label>
        <el-date-picker
          v-model="dateRange"
          :picker-options="{ disabledDate: validationDayDisabledDate }"
          @input="sendChange"
          type="daterange"
          range-separator="-"
          start-placeholder="Data início"
          end-placeholder="Data fim"
          unlink-panels
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy">
        </el-date-picker>
      </div>
      <div class="col-6 col-md-3">
        <base-input
          class="mb-3"
          @input="sendChange"
          v-model="days"
          placeholder="Ex: 90"
          label="Dias"
          :disabled="true"
          prependIcon="fa fa-calendar"
          type="number"
          success-message="Campo preenchido"
        >
        </base-input>
      </div>
    </div>
    <hr />
    <div class="row justify-content-md-center">
      <div class="col-12"><h3>Fases do Ciclo</h3></div>
      <div class="col-12 col-md-2"><h4>Pré-Plantio</h4></div>
      <div class="col-4 col-md-3">
        <base-input
          class="mb-3"
          @input="sendChange"
          v-model="prePlantingDays"
          :error="(prePlantingDays == 0 ? 'Dias devem ser maiores que zero' : null)"
          placeholder="Ex: 30"
          label="Dias"
          mask="volume"
        >
        </base-input>
      </div>
      <div class="col-4 col-md-3 form-group">
        <label class="form-control-label">Inicio da Fase</label><br />
        <el-date-picker
          v-model="prePlantingStart"
          :key="Math.abs(prePlantingStart)"
          :picker-options="{ disabledDate: prePlantingDisabledDate }"
          @input="sendChange"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-4 form-group">
        <label class="form-control-label">Fim da Fase</label><br />
        <el-date-picker
          v-model="plantingStart"
          :key="Math.abs(plantingStart)"
          :picker-options="{ disabledDate: prePlantingDisabledDate }"
          @input="sendChange"
          :disabled="true"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-12 col-md-2"><h4>Plantio</h4></div>
      <div class="col-4 col-md-3">
        <base-input
          class="mb-3"
          @input="sendChange"
          v-model="plantingDays"
          placeholder="Ex: 30"
          :error="
            plantingDays < 0 ? 'Dias de plantio não pode ser menor que 0' : null
          "
          mask="volume"
        >
        </base-input>
      </div>
      <div class="col-4 col-md-3 form-group">
        <el-date-picker
          v-model="plantingStart"
          :key="Math.abs(plantingStart)"
          @input="sendChange"
          :disabled="true"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-4 form-group">
        <el-date-picker
          v-model="growingStart"
          :key="Math.abs(growingStart)"
          :picker-options="{ disabledDate: plantingDisabledDate }"
          @input="sendChange"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-12 col-md-2"><h4>Crescimento</h4></div>
      <div class="col-4 col-md-3">
        <base-input
          class="mb-3"
          @input="sendChange"
          v-model="growingDays"
          :error="
            growingDays < 0
              ? 'Dias de crescimento não pode ser menor que 0'
              : null
          "
          placeholder="Ex: 30"
          mask="volume"
        >
        </base-input>
      </div>
      <div class="col-4 col-md-3 form-group">
        <el-date-picker
          v-model="growingStart"
          :key="Math.abs(growingStart)"
          @input="sendChange"
          :disabled="true"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-4 form-group">
        <el-date-picker
          v-model="harvestStart"
          :key="Math.abs(harvestStart)"
          :picker-options="{ disabledDate: posgrowingDisabledDate }"
          @input="sendChange"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-12 col-md-2"><h4>Colheita</h4></div>
      <div class="col-4 col-md-3">
        <base-input
          class="mb-3"
          @input="sendChange"
          v-model="harvestDays"
          :disabled="true"
          :error="
            harvestDays < 0 ? 'Dias de colheita não pode ser menor que 0' : null
          "
          placeholder="Ex: 30"
          mask="volume"
        >
        </base-input>
      </div>
      <div class="col-4 col-md-3 form-group">
        <el-date-picker
          v-model="harvestStart"
          :key="Math.abs(harvestStart)"
          :disabled="true"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
      <div class="col-4 form-group">
        <el-date-picker
          v-model="end"
          :key="Math.abs(end)"
          :picker-options="{ disabledDate: growingDisabledDate }"
          :disabled="true"
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        >
        </el-date-picker>
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { DatePicker } from "element-ui";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  components: {
    Multiselect,
    ValidationProvider,
    [DatePicker.name]: DatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    copyCicle: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      anosafras: [],
      anosafra: {},
      options: [
        { label: "Safrinha", value: 1 },
        { label: "Semente", value: 2 },
        { label: "Verão", value: 3 },
      ],
      classification_options: [
        {
          origin: "Novo",
          classifications: [{ name: "", id: "new" }],
        },
        {
          origin: "Dessa Cultura",
          classifications: [],
        },
        {
          origin: "Todas",
          classifications: [],
        },
      ],
      clients: [],
      cicles: [],
      ciclesOptions: [],
      prePlantingStart: this.value.prePlantingStart,
      plantingStart: this.value.plantingStart,
      growingStart: this.value.growingStart,
      harvestStart: this.value.harvestStart,
      anosafra_id: this.value.anosafra_id,
      endDate: this.value.end,
    };
  },
  methods: {
    distanceInDays(date1, date2) {
      const diffInMs = new Date(date2) - new Date(date1)
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return Math.ceil(diffInDays);
    },
    // changeRoute() {
    //   this.value.description = this.value.cicle.description;
    //   this.value.cicle_classification = this.value.cicle.cicle_classification;
    //   this.value.anosafra_id = this.value.cicle.anosafra_id;
    //   this.value.end = this.value.cicle.end;
    //   this.value.prePlantingStart = this.value.cicle.prePlantingStart;
    //   this.value.plantingStart = this.value.cicle.plantingStart;
    //   this.value.growingStart = this.value.cicle.growingStart;
    //   this.value.harvestStart = this.value.cicle.harvestStart;
    // },
    sendChange() {
      this.value.prePlantingStart = this.prePlantingStart;
      this.value.plantingStart = this.plantingStart;
      this.value.growingStart = this.growingStart;
      this.value.harvestStart = this.harvestStart;
      this.value.anosafra_id = this.value.anosafra ? this.value.anosafra.id : '';
      this.value.end = this.endDate;

      if (this.value.cicle_classification && this.value.cicle_classification.id == "new") {
        this.value.cicle_classification_attributes = {
          name: this.value.cicle_classification.name,
        };
        delete this.value.cicle_classification_id;
      } else if (this.value.cicle_classification) {
        this.value.cicle_classification_id = this.value.cicle_classification.id;
        delete this.value.cicle_classification_attributes;
      }

      if (!this.value.client_id) {
        this.value.client_id = 0;
      }

      this.$emit("input", this.value);
    },
    getAnosafras() {
      this.$http.secured
        .get("/api/v1/anosafras")
        .then(response => {
          this.anosafras = response.data.anosafras
          // this.anosafra = response.data.anosafras[0];
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    getClients(q = "") {
      this.$http.secured
        .get("/api/v1/clients", { params: { q: { razao_social: q } } })
        .then((response) => {
          this.clients = response.data["clients"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    validationDayDisabledDate(time) {
      return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
    },
    prePlantingDisabledDate(time) {
      return time.getTime() >= this.plantingStart;
    },
    posgrowingDisabledDate(time) {
      return time.getTime() <= this.growingStart;
    },
    plantingDisabledDate(time) {
      return time.getTime() < this.plantingStart;
    },
    growingDisabledDate(time) {
      return time.getTime() >= this.endDate;
    },
    loadCicleClassifications() {
      if (this.value.culture && this.value.culture.id) {
        this.$http.secured
          .get(
            `/api/v1/cultures/${this.value.culture.id}/cicle_classifications`
          )
          .then(
            (response) =>
              (this.classification_options[1].classifications = response.data)
          );
      }
      this.$http.secured
        .get("/api/v1/cicle_classifications")
        .then(
          (response) =>
            (this.classification_options[2].classifications = response.data)
        );
    },
    updateNewClassificationName(name) {
      if (name) {
        this.classification_options[0].classifications[0].name = name;
      }
    }
  },
  computed: {
    days: {
      get() {
        if (!(this.plantingStart && this.endDate)) return;

        return this.distanceInDays(this.plantingStart, this.endDate);
      },
      set(newDays) {
        if (this.plantingStart) {
          const endDateObj = new Date(this.plantingStart)
          this.endDate = new Date(endDateObj.setDate(endDateObj.getDate() + newDays))
        }
      },
    },
    prePlantingDays: {
      get() {
        if (!(this.plantingStart && this.prePlantingStart)) return;

        return this.distanceInDays(this.prePlantingStart, this.plantingStart);
      },
      set(newDays) {
        if (this.plantingStart) {
          const date = new Date(this.plantingStart);
          this.prePlantingStart = new Date(date.setDate(date.getDate() -  newDays))
        }
      },
    },
    plantingDays: {
      get() {
        if (!(this.plantingStart && this.growingStart)) return;

        return this.distanceInDays(this.plantingStart, this.growingStart);
      },
      set(newDays) {
        if (this.plantingStart) {
          const plantingStartDateObj = new Date(this.plantingStart)
          this.growingStart = new Date(plantingStartDateObj.setDate(plantingStartDateObj.getDate() + newDays))
        }
      },
    },
    growingDays: {
      get() {
        if (!(this.growingStart && this.harvestStart)) return;

        return this.distanceInDays(this.growingStart, this.harvestStart);
      },
      set(newDays) {
        if (this.growingStart) {
          const growingStartDateObj = new Date(this.growingStart)
          this.harvestStart = new Date(growingStartDateObj.setDate(growingStartDateObj.getDate() + newDays))
        }
      },
    },
    harvestDays: {
      get: function () {
        if (!(this.harvestStart && this.endDate)) return;

        return this.distanceInDays(this.harvestStart, this.endDate);
      },
    },
    dateRange: {
      get: function () {
        return [this.plantingStart, this.endDate];
      },
      set: function (range) {
        this.plantingStart = range[0];
        this.endDate = range[1]
      },
    },
  },
  watch: {
    value: function () {
      this.loadCicleClassifications();
      this.getClients();
      this.getAnosafras();
      this.prePlantingStart = this.value.prePlantingStart;
      this.plantingStart = this.value.plantingStart;
      this.growingStart = this.value.growingStart;
      this.harvestStart = this.value.harvestStart;
      this.endDate = this.value.end;
    },
  },
};
</script>
